import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "ponctualité, toujours",
    text: "Nous arrivons à l'heure annoncée et nous terminons dans les délais convenus. Votre temps est aussi précieux que le nôtre.",
  },
  {
    n: "02",
    title: "un travail soigné",
    text: "Chaque intervention est réalisée proprement, dans les règles de l'art. Nous ne partons que lorsque tout est impeccable.",
  },
  {
    n: "03",
    title: "un devis clair",
    text: "Pas de mauvaise surprise : le prix annoncé est le prix respecté. Vous savez toujours ce que vous payez, et pourquoi.",
  },
];

export const Manifesto = () => (
  <section
    id="engagements"
    className="px-6 md:px-12 py-32 md:py-48"
    data-testid="engagements-section"
  >
    <motion.p
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      className="text-xs uppercase tracking-[0.3em] text-gold mb-20"
      data-testid="manifesto-overline"
    >
      Nos engagements
    </motion.p>

    <div className="space-y-32 md:space-y-40">
      {chapters.map((c, i) => (
        <motion.div
          key={c.n}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className={`relative md:w-3/4 ${i % 2 === 1 ? "md:ml-auto" : ""}`}
          data-testid={`manifesto-chapter-${c.n}`}
        >
          <span
            aria-hidden="true"
            className="absolute -top-16 md:-top-24 -left-2 md:-left-8 font-serif text-[8rem] md:text-[13rem] leading-none text-bone opacity-[0.06] select-none"
          >
            {c.n}
          </span>
          <div className="relative z-10 md:pl-24">
            <p className="text-xs tracking-[0.25em] text-gold mb-6">chapitre {c.n}</p>
            <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-none mb-8">
              {c.title}
            </h2>
            <p className="text-sm md:text-base text-ash leading-relaxed font-light max-w-lg">
              {c.text}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
